// extracted by mini-css-extract-plugin
export default {"body":"Investments_body__EFEHh","stat":"Investments_stat__ib-7j"};